import lotImage from '../../../assets/img/lot-img.png'

const capitalize = (value) => {
  if (!value) return ''
  return value.charAt(0).toUpperCase() + value.slice(1)
}

const subjectName = (subject) => {
  if (!subject) return ''
  return subject.tradingName ||
    [subject.firstName, subject.lastName].filter(Boolean).join(' ')
}

const locationText = (lot) => {
  const loc = (lot && lot.publicDetails && lot.publicDetails.location) || {}
  return [loc.town, loc.state].filter(Boolean).join(', ').toUpperCase()
}

const priceText = (lot) => {
  if (!lot || !lot.price) return ''
  const per = lot.bidding === 'kg' ? 'kg' : 'Head'
  return `$${(lot.price / 100).toFixed(2)}/${per}`
}

const buildTags = (lot) => {
  const pd = (lot && lot.publicDetails) || {}
  return [
    pd.summary && pd.summary.age,
    pd.weight && pd.weight.average ? `${Math.round(pd.weight.average)}kg avg` : null,
    pd.majorBreed
  ].filter(Boolean)
}

/**
 * Map a Survey document from the API into the shape the Surveys page renders.
 * Buyer surveys are shown as "Purchased", seller surveys as "Sold".
 */
const mapSurvey = (survey) => {
  const lot = survey.lot || {}
  return {
    id: survey._id,
    type: survey.role === 'seller' ? 'Sold' : 'Purchased',
    stockType: (lot.kindData && lot.kindData.type) || '',
    date: survey.createdAt,
    status: survey.status,
    lot: {
      lotName: lot.number != null ? `Lot ${lot.number}` : 'Lot',
      title: (lot.publicDetails && lot.publicDetails.title) || '',
      location: locationText(lot),
      status: capitalize(lot.status),
      price: priceText(lot),
      image: (lot.media && lot.media[0] && lot.media[0].url) || lotImage,
      agent: (lot.creatorData && lot.creatorData.tradingName) || '',
      assessorName: subjectName(survey.subject),
      tags: buildTags(lot),
      kindTitle: (lot.kindData && lot.kindData.title) || (lot.kindData && lot.kindData.type) || '',
      searchNumber: (lot.auctionData && lot.auctionData.searchNumber) || lot.searchNumber || '',
      searchNumericId: lot.searchNumericId || ''
    },
    questions: (survey.answers || []).map(answer => ({
      id: String(answer.question),
      text: answer.title,
      rating: answer.rating || 0
    }))
  }
}

export default mapSurvey
